
export const text = `[VIDEO ID: A video of a busy street corner. It appears to have been taken from a balcony. The city is packed with pedestrians, and there is a traffic jam on the road-- car horns blare from the street below. The camera zooms in on a woman in a black trench coat as she makes her way across the street. She turns a corner, and stops in front of an old-looking building. Once she is out of frame,
    the video ends.]
    



`